import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import { Button } from '@mui/material'

import { CaretUpIcon, CaretDownIcon } from '@src/icons'

const useStyles = makeStyles()((theme) => ({
  button: {
    padding: theme.spacing(2, 8),
    maxHeight: 42,
  },
  caret: {
    fontSize: theme.typography.pxToRem(9),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1 / 2),
  },
}))

interface TogglePricingButtonProps {
  expanded: boolean
  onToggle: () => void
}

const TogglePricingButton = ({
  expanded,
  onToggle,
}: TogglePricingButtonProps) => {
  const { classes } = useStyles()

  return (
    <Button
      variant="outlined"
      className={classes.button}
      color="primary"
      onClick={onToggle}
      data-testid="srp-view-options-button"
    >
      {!expanded ? (
        <FormattedMessage id="VIEW_PRICING" defaultMessage="View Pricing" />
      ) : (
        <FormattedMessage id="HIDE_PRICING" defaultMessage="Hide Pricing" />
      )}
      {expanded ? (
        <CaretUpIcon className={classes.caret} data-testid="caret-up-icon" />
      ) : (
        <CaretDownIcon
          className={classes.caret}
          data-testid="caret-down-icon"
        />
      )}
    </Button>
  )
}

export default TogglePricingButton
